import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { h } from '@app/helpers/translationHelper'
import LoginFormContainer from '@app/containers/Landing/LoginFormContainer'
import SVG from 'react-inlinesvg'

import AnalyticsManager, { PageEventsTypes } from '@app/analytics/manager'
import rulesIcon from '@icons/footer/footer-rules'
import agreementIcon from '@icons/footer/footer-agreement'
import privacyIcon from '@icons/footer/footer-privacy'
import downloadIcon from '@icons/download/white'
import classnames from 'classnames'

const localeMapper = () => {
  switch(window.COUNTRY) {
  case 'IN':
    let suffix;

    switch(I18n.locale) {
    case 'mr':
    case 'hi':
      suffix = I18n.locale
      break
    default:
      suffix = 'en'
    }

    return `/poster-${window.COUNTRY}-${suffix}.pdf`
      default:
      return `/poster-${window.COUNTRY}.pdf`;
  }
}

const Content = (props) => {
  return (
    <div className="select-list">
      <Link to="/rules" className="select-list__item">
        <div className="select-list__mark f--text">
          <SVG src={rulesIcon} />
        </div>
        <div className="select-list__option f--text f--l f--upper">
          { I18n.t('landing.rules_html') }
        </div>
      </Link>

      { window.COUNTRY == 'ZA' || window.COUNTRY == 'CN' ? null : (
          <a 
            href={localeMapper()} 
            target="_blank" 
            className="select-list__item" 
            data-external-link
            data-action="downloadCertificate"
            onClick={() => {
              AnalyticsManager.emitPageEvent(PageEventsTypes.OlympDownloadPosterClick);
            }}
          >
            <div className="select-list__mark f--text">
              <SVG src={downloadIcon} />
            </div>
            <div className="select-list__option f--text f--l f--upper">
              { I18n.t('landing.download_poster') }
            </div>
          </a>
        )
      }

      <div className="select-list__item">
        <div className="select-list__mark f--text">
          <SVG src={agreementIcon} />
        </div>
        <div className="select-list__option">
          <div>
            <span className="f--text f--l f--regular"
              dangerouslySetInnerHTML={ h('landing.if_any_questions_html') }
            />
            &nbsp;
            <a 
              style={{ color: '#2E3846' }} 
              className="link f--text" 
              href="mailto:support@dinolab.com"
              data-external-link
              data-action="supportCustomerCare"
            >
              support@dinolab.com
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export const FooterWithForm = (props) => {
  const classes = classnames('section', 'footer-section')

  return (
    <footer className={classes}>
      <div className="grid grid--md-2--kv-reverse grid--xl-2--kv-reverse">
        <div className="footer-section__form">
          <div className="landing-form">
            <div className="landing-form__content">
              <h3 className="landing-form__heading mb-gutter-s">
                { I18n.t('auth.heading') }
              </h3>
              <LoginFormContainer prefix="footer-" />
            </div>
          </div>
        </div>

        <Content />
      </div>
    </footer>
  )
}

const Footer = (props) => {
  const classes = classnames('section', 'footer-section')

  return (
    <footer className={classes}>
      <Content />
    </footer>
  )
}

export default Footer
